interface LoginWithPasswordParams {
  username: string
  password: string
}

export enum CaptchaType {
  Sms = 0,
  Email = 1,
  Unkonwn = 'unkonwn'
}

interface SendVerificationCodeParams {
  loginName: string
  loginType: CaptchaType
}

interface LoginWithVerificationCodeParams extends SendVerificationCodeParams {
  verificationCode: string
}

interface LoginInfo {
  ipAddress: string
  location: string
  browser: string
  operationSystem: string
  loginTime: number
}

export enum Roles {
  Admin = 0,
  Maintenance,
  Business
}

interface RoleInfo {
  id: string
  roleName: null
  dataScope: string
  orgIdSet: string[]
  roleKey: Roles
  permissions: string[]
}

interface LoginUser {
  id: string
  cachedKey: string
  username: string
  loginInfo: LoginInfo
  orgId: string
  roleInfo: RoleInfo
  autoRefreshCacheTime: number
  roleKey: string
  admin: boolean
  enabled: boolean
}

interface LoginResponse {
  token: string
  loginUser: LoginUser
}

export enum LoginType {
  Account = 'account',
  Captcha = 'captcha'
}

export type {
  LoginWithPasswordParams,
  SendVerificationCodeParams,
  LoginWithVerificationCodeParams,
  LoginResponse,
  LoginInfo,
  RoleInfo,
  LoginUser
}
